import { Components } from "@thisgorilla/primate-ds";
import { AnimatePresence, motion } from "framer-motion";
import styled from "styled-components";
import { useImageContentContext } from ".";
import { FlexRowSpaced } from "../../../../../../Common/Styles";
import { ImageContentProps } from "./imageContent";

export const ExpandedPostCarousel = ({
  onNextClick,
  onPrevClick,
}: ImageContentProps.Carousel) => {
  const { carouselIndex, Images } = useImageContentContext();

  return (
    <CarouselContainer className="image-carousel-expanded-post">
      {carouselIndex === 0 && <div />}
      <AnimatePresence>
        {carouselIndex > 0 && (
          <ButtonContainer
            initial={{ transform: "translateX(100%)" }}
            animate={{ transform: "translateX(0)" }}
            exit={{ transform: "translateX(100%)" }}
            transition={{ duration: 0.3 }}
          >
            <Components.IconButton
              disabled={false}
              iconType="ChevronLeft"
              kind="Floating"
              onClick={onPrevClick}
              size="XS"
            />
          </ButtonContainer>
        )}
      </AnimatePresence>
      <AnimatePresence>
        {carouselIndex < Images.length - 1 && (
          <ButtonContainer
            initial={{ transform: "translateX(0)" }}
            animate={{ transform: "translateX(calc(100% - 2rem))" }}
            exit={{ transform: "translateX(0)" }}
            transition={{ duration: 0.3 }}
          >
            <Components.IconButton
              disabled={false}
              iconType="ChevronRight"
              kind="Floating"
              onClick={onNextClick}
              size="XS"
            />
          </ButtonContainer>
        )}
      </AnimatePresence>
    </CarouselContainer>
  );
};

const CarouselContainer = styled(FlexRowSpaced)`
  padding: ${({ theme }) => theme.spacing["spacing-1"].value}rem;
  position: absolute;
  width: 100%;
  align-items: center;
`;
const ButtonContainer = styled(motion.span)`
  position: absolute;
  width: 100%;
`;
